import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from './Brand';
import { Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0B1F3A] text-white/85 mt-20" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Wordmark light />
            <p className="mt-5 text-sm leading-relaxed text-white/70 max-w-md">
              TRJ Academy™ is a professional educational institution operated by TRJ Services, Inc.
              We deliver practical training, certification, and career advancement for taxation,
              accounting, and business professionals.
            </p>
            <div className="mt-6 space-y-2 text-sm text-white/70">
              <div className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold" /> info@trjacademy.com</div>
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-gold" /> United States · Online Campus</div>
            </div>
          </div>

          <div>
            <div className="font-display font-semibold text-white mb-4 text-sm tracking-wide uppercase">Academy</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-gold">About</Link></li>
              <li><Link to="/schools" className="hover:text-gold">Schools</Link></li>
              <li><Link to="/programs" className="hover:text-gold">Programs</Link></li>
              <li><Link to="/admissions" className="hover:text-gold">Admissions</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-display font-semibold text-white mb-4 text-sm tracking-wide uppercase">Students</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/student-services" className="hover:text-gold">Student Services</Link></li>
              <li><Link to="/student-handbook" className="hover:text-gold">Student Handbook</Link></li>
              <li><Link to="/login" className="hover:text-gold">Student Portal</Link></li>
              <li><Link to="/dashboard" className="hover:text-gold">Dashboard</Link></li>
              <li><Link to="/contact" className="hover:text-gold">Support</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-display font-semibold text-white mb-4 text-sm tracking-wide uppercase">Legal</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/legal/terms" className="hover:text-gold">Terms & Conditions</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-gold">Privacy Policy</Link></li>
              <li><Link to="/legal/refund" className="hover:text-gold">Refund Policy</Link></li>
              <li><Link to="/legal/disclaimer" className="hover:text-gold">Disclaimer</Link></li>
              <li><Link to="/legal/accessibility" className="hover:text-gold">Accessibility</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/60">© {new Date().getFullYear()} TRJ Academy™. A division of TRJ Services, Inc. All rights reserved.</p>
          <p className="text-xs text-white/60 font-serif italic">Professional Education. Practical Application. Career Advancement.™</p>
        </div>
      </div>
    </footer>
  );
}
